import * as React from "react"

export function useGridColumns() {
  const [columns, setColumns] = React.useState(3)
  
  React.useEffect(() => {
    const updateColumnCount = () => {
      if (window.innerWidth >= 1024) {
        setColumns(3) // large screens
      } else if (window.innerWidth >= 768) {
        setColumns(2) // medium screens
      } else {
        setColumns(1) // mobile
      }
    }
    
    // Initial check
    updateColumnCount()
    
    // Update on resize
    window.addEventListener('resize', updateColumnCount)
    
    return () => window.removeEventListener('resize', updateColumnCount)
  }, [])
  
  return columns
}
